<template>
  <div>
    <div class="bill_content_wrap">
      <h2>CHI TIẾT CÁC KHOẢN PHÍ</h2>
      <div class="bill_content px-4" style="border: 1px solid #e0e0e0; border-radius: 4px">
        <ChildGroupFee title="KHOẢN PHÍ" :collections="getCollection(getHeadFees('main-sum'))" />
        <ChildGroupFee title="KHOẢN GIẢM TRỪ" :collections="getCollection(getHeadFees('main-minus'))" />
        <ChildGroupFee title="KHOẢN TRUY THU" :collections="getCollection(getHeadFees('sub-sum'))" />
        <ChildGroupFee title="KHOẢN HOÀN TRẢ" :collections="getCollection(getHeadFees('sub-minus'))" />
        <div class="total_money mb-2">
          <h3>KHOẢN TIỀN PHẢI NỘP</h3>
          <span>{{ getTotalMoney(report) | price }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { get } from 'lodash'
import ChildGroupFee from '@/modules/tuitionFee/detail-period/ChildGroupFee.vue'
export default {
  props: {
    kind: String
  },
  components: {
    ChildGroupFee
  },
  computed: {
    ...mapGetters({
      report: 'tuitionFeeReport/report',
      collections: 'tuitionFeeCollection/collections',
      detailPeriod: 'tuitionFeePeriod/detailPeriod'
    })
  },
  data() {
    return {
      tab: null,
      loading: false,
      note: ''
    }
  },
  methods: {
    ...mapActions('tuitionFeeReport', ['editNotePeriod']),
    getHeadFees(type) {
      // ['main-sum', 'main-minus', 'sub-sum', 'sub-minus']
      let feesHaveAmount = type === 'main-sum' || type === 'sub-sum' ? this.report.sumFees : this.report.minusFees
      return Object.keys(feesHaveAmount)
        .map(key => {
          let info = this.report.head_fees.find(headFee => headFee.id === key)
          if (this.kind !== null) {
            if (this.kind === 'cen' && info.kind !== 'cen') return
            if (this.kind === 'decen' && info.kind !== 'decen') return
          }
          let isSubFee = type.includes('sub')
          let isSumFee = type.includes('sum') ? 'normal' : 'priority'
          if (info && info.isSubFee === isSubFee && info.type === isSumFee) {
            let amount = get(feesHaveAmount[key], 'amount', 0)
            let type = get(feesHaveAmount[key], 'type')
            info.amount = isSumFee === 'normal' ? amount : this.getSpecificMinusFee({ ...info, amount, type })
            let notes = feesHaveAmount[key].notes
            if (!notes) {
              notes = get(info, 'metadata.subNote', '')
            }
            info.notes = notes
            return info
          }
        })
        .filter(a => a !== undefined && a.amount !== 0)
        .sort((a, b) => a.rank - b.rank)
    },
    getSpecificMinusFee(minusFee) {
      if (minusFee.type === 'fixed') {
        return minusFee.amount
      } else {
        let item = this.report.sumFees[minusFee.head_fee_apply]
        return item ? (minusFee.amount * this.report.sumFees[minusFee.head_fee_apply].amount) / 100 : 0
      }
    },
    getCollection(headFees) {
      let collections = {}
      for (const headFee of headFees) {
        const collection = headFee.head_fee_collection
        collections[get(collection, 'id', 'no-group')] = {
          title: get(collection, 'title', 'Khoản phí khác'),
          rank: get(collection, 'rank', 100),
          children: {}
        }
      }
      for (const headFee of headFees) {
        const collection = headFee.head_fee_collection
        collections[get(collection, 'id', 'no-group')].children[headFee.id] = headFee
      }
      return collections
    },
    async openNote() {
      this.note = this.report.notes
    },
    getTotalMoney(report) {
      if (this.kind === 'cen' || this.kind === 'decen') return report[this.kind].totalAmount
      return report.totalAmount
    },

    getAmountPaid(report) {
      if (this.kind === 'cen' || this.kind === 'decen') return report[this.kind].amountPaid
      return report.amountPaid
    },
    async save() {
      try {
        this.loading = true
        let params = {
          id: this.report.id,
          notes: this.note,
          isUseNote: !!this.note
        }
        await this.editNotePeriod(params)
        this.$alert.success('Đã ghi chú thành công!')
        this.loading = false
      } catch (e) {
        this.loading = false
        this.$alert.error({ title: 'Lỗi kết nối', description: 'Không thể lưu ghi chú. Vui lòng thử lại' })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.bill_content {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.total_money h3 {
  font-weight: bold;
  font-size: 18px !important;
}
.tab-active {
  color: #0d47a1 !important;
  background-color: #ffffff !important;
  border: 1px solid #ffffff;
}
.tab-default {
  color: #000;
  background-color: #ffffff;
}
</style>
